import script from "./RiskDisclosure.vue?vue&type=script&setup=true&lang=js"
export * from "./RiskDisclosure.vue?vue&type=script&setup=true&lang=js"

import "./RiskDisclosure.vue?vue&type=style&index=0&id=01355470&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01355470"]])

export default __exports__